export default __webpack_public_path__ + "media/images/portrait/small/avatar-s-5-c0bd6135d0c4c570906eb17787503375.png";